import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InputTypes } from 'src/app/enums/input-types.enum';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  standalone: false
})
export class DialogComponent {
  readonly InputTypes = InputTypes;
  value: any;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      message: string,
      messages: string[],
      title: string,
      closeMessage: string,
      canCancel: boolean,
      canClose: boolean,
      actions: any,
      icon: string,
      inputType?: InputTypes,
      defaultValue?: any,
  }) {
    this.dialogRef.addPanelClass('bg-dark');
    this.data.canClose = this.data.canClose ?? true;
    this.value = data.defaultValue;
  }

  cancel(): void {
    this.dialogRef.close()
  }

  execute(action: () => void): void {
    if(action)
      action()

    if(this.data.canClose)
      this.dialogRef.close()
  }

}
